import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, apiError } from "@/lib/api";
import { ArrowLeft, Loader2, Shield, User, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await adminApi.post("/admin/login", { username: username.trim(), password });
      localStorage.setItem("mrshu_admin_token", data.token);
      toast.success("Signed in");
      nav("/admin");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-primary flex flex-col">
      <div className="absolute inset-0 grain-overlay" />
      <div className="relative z-10 max-w-md mx-auto w-full px-6 py-8 flex-1 flex flex-col">
        <button data-testid="admin-back-btn" onClick={() => nav("/")}
          className="flex items-center gap-2 text-secondary/90 font-medium mb-6">
          <ArrowLeft className="h-5 w-5" /> Back
        </button>
        <div className="flex flex-1 flex-col justify-center">
          <div className="flex flex-col items-center text-center mb-8">
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary">
              <Shield className="h-8 w-8 text-primary" />
            </div>
            <h1 className="font-display text-3xl font-bold text-secondary mt-4">Admin Dashboard</h1>
            <p className="text-secondary/70 text-sm mt-1">MR SHU Handyman · Christchurch</p>
          </div>
          <div className="rounded-3xl bg-background p-6 shadow-xl space-y-5">
            <div>
              <label className="block text-sm font-semibold text-primary mb-2">Username</label>
              <div className="relative">
                <User className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-primary/60" />
                <input data-testid="admin-username-input" value={username} onChange={(e) => setUsername(e.target.value)}
                  className="w-full h-14 pl-12 pr-4 rounded-2xl border border-input bg-white focus:ring-2 focus:ring-primary focus:outline-none" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-primary mb-2">Password</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-primary/60" />
                <input data-testid="admin-password-input" value={password} type="password"
                  onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()}
                  className="w-full h-14 pl-12 pr-4 rounded-2xl border border-input bg-white focus:ring-2 focus:ring-primary focus:outline-none" />
              </div>
            </div>
            <button data-testid="admin-login-btn" onClick={submit} disabled={busy} className="btn-primary">
              {busy ? <Loader2 className="h-6 w-6 animate-spin" /> : "Sign in"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
